import React from 'react';
// import { Drawer } from 'antd';
import { withRouter, RouteComponentProps } from 'dva/router';
import kv from '@/assets/image/mvideo/kv.jpg';
// import data from './config';
import styles from './index.less';

interface IMenuProps {

}
const Menu: React.FC<IMenuProps & RouteComponentProps> = ({ location, history }) => {
  // const [visible, setVisible] = useState(false);
  // const currentKey = useMemo(() => {
  //   return location.pathname.split('/').slice(0, 3).join('/');
  // }, [location.pathname]);

  // const showDrawer = () => {
  //   setVisible(true);
  // };

  // const onClose = () => {
  //   setVisible(false);
  // };

  // const scrollToAnchor = (anchorName?: string) => {
  //   history.push('/app/home');
  //   setTimeout(() => {
  //     if (anchorName) {
  //       // 找到锚点
  //       const anchorElement = document.getElementById(anchorName);
  //       // 如果对应id的锚点存在，就跳转到锚点
  //       if (anchorElement) {
  //         onClose();
  //         window.scrollTo(0, anchorElement.offsetTop - 86 || 0);
  //       }
  //     }
  //   }, 300);
  // };
  return (
    <div className={styles.menu}>
      <div className={styles.menuContent}>
        <div className={styles.logo}>
          <img src={kv} alt="" />
        </div>
        {/* <div className={styles.icon} onClick={showDrawer}>
          <img src={iconMenuImg} alt="" />
        </div> */}
      </div>
      {/* <Drawer
        placement="right"
        closable={false}
        onClose={onClose}
        visible={visible}
        className={styles.drawer}
        getContainer={false}
        width={148}
      >
        <div className={styles.menuList}>
          <div className={styles.menuItemClose} onClick={onClose}><span>X</span></div>
          {data.map(item => {
            if (item.type === 'anchor') {
              return (
                <a key={item.key} onClick={() => scrollToAnchor(item.key)}>
                  <div className={item.key === currentKey ? styles.menuItemSelected : styles.menuItem}>{item.title}</div>
                </a>
              );
            }
            if (item.type === 'a') {
              return (
                <a key={item.key} target="_blank" href={item.key}>
                  <div className={item.key === currentKey ? styles.menuItemSelected : styles.menuItem}>{item.title}</div>
                </a>
              );
            }
            return (
              <Link to={item.key} key={item.key} onClick={onClose}>
                <div className={item.key === currentKey ? styles.menuItemSelected : styles.menuItem}>{item.title}</div>
              </Link>
            );
          })}
        </div>

      </Drawer> */}
    </div>
  );
};

export default withRouter(Menu);
